(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-product-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blocky-slider-1')) {
  customElements.define('blocky-slider-1',
    class BlockySlider1 extends HTMLElement {
      constructor() {
        super()

        let nextButton = this.querySelector('#next');
        let prevButton = this.querySelector('#prev');
        
        nextButton.addEventListener("click", () => {
            this.showSlider('next');
        })
        prevButton.addEventListener("click", () => {
            this.showSlider('prev');
        })
      }

      showSlider(type) {      
        let listHTML = this.querySelector('.blocky-slider-container');

        this.classList.remove('next', 'prev');
        let items = this.querySelectorAll('.slide');
        if(type === 'next'){
          listHTML.appendChild(items[0]);
          this.classList.add('next');          
        } else{
          listHTML.prepend(items[items.length - 1]);
          this.classList.add('prev');
        }
      }
    }
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-header-section"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-altis-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dr-section]').forEach(function (root) {
    const mainImage = root.querySelector('[data-product-main]');
    const productMain = mainImage ? mainImage.closest('.dr-product-main') : null;
    const featureTrack = root.querySelector('[data-feature-track]');
    const featurePrev = root.querySelector('[data-feature-prev]');
    const featureNext = root.querySelector('[data-feature-next]');
    const featureCards = featureTrack ? Array.from(featureTrack.querySelectorAll('.dr-feature-card')) : [];
    const hero = root.querySelector('.dr-hero');
    const heroSlides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const heroPrev = root.querySelector('[data-hero-prev]');
    const heroNext = root.querySelector('[data-hero-next]');
    const heroStatus = root.querySelector('[data-hero-status]');
    const heroProgress = root.querySelector('[data-hero-progress]');
    const indexTabs = Array.from(root.querySelectorAll('[data-index-tab]'));
    const indexPanels = Array.from(root.querySelectorAll('[data-index-panel]'));
    const stickyBar = root.querySelector('.dr-sticky-atc');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let heroIndex = 0;
    let heroTimer;
    let featureIndex = 0;

    function showHero(nextIndex) {
      if (heroSlides.length < 2) return;
      heroIndex = (nextIndex + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (slide, index) {
        const isActive = index === heroIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      if (heroStatus) {
        heroStatus.textContent =
          String(heroIndex + 1).padStart(2, '0') + ' / ' + String(heroSlides.length).padStart(2, '0');
      }
      if (heroProgress) {
        heroProgress.style.width = 100 / heroSlides.length + '%';
        heroProgress.style.transform = 'translateX(' + heroIndex * 100 + '%)';
      }
    }

    function stopHero() {
      window.clearInterval(heroTimer);
    }

    function startHero() {
      stopHero();
      if (heroSlides.length > 1 && window.innerWidth > 820 && !reducedMotion) {
        heroTimer = window.setInterval(function () {
          showHero(heroIndex + 1);
        }, 5200);
      }
    }

    if (heroPrev && heroNext) {
      heroPrev.addEventListener('click', function () {
        showHero(heroIndex - 1);
        startHero();
      });
      heroNext.addEventListener('click', function () {
        showHero(heroIndex + 1);
        startHero();
      });
      hero.addEventListener('mouseenter', stopHero);
      hero.addEventListener('mouseleave', startHero);
      hero.addEventListener('focusin', stopHero);
      hero.addEventListener('focusout', startHero);
      showHero(0);
      startHero();
    }

    root.querySelectorAll('[data-gallery-image]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-gallery-image]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        if (mainImage && productMain) {
          productMain.classList.add('is-changing');
          mainImage.removeAttribute('srcset');
          mainImage.addEventListener(
            'load',
            function () {
              productMain.classList.remove('is-changing');
            },
            { once: true }
          );
          mainImage.src = button.dataset.galleryImage;
          window.setTimeout(function () {
            productMain.classList.remove('is-changing');
          }, 650);
        }
      });
    });

    root.querySelectorAll('[data-pack]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-pack]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        root.querySelectorAll('[data-selected-price]').forEach(function (item) {
          item.textContent = button.dataset.price;
        });
        root.querySelectorAll('[data-sticky-price]').forEach(function (item) {
          item.textContent = button.dataset.price;
        });
        const quantity = root.querySelector('[data-product-quantity]');
        if (quantity) quantity.value = button.dataset.quantity;
      });
    });

    const previewButton = root.querySelector('[data-preview-add]');
    if (previewButton) {
      previewButton.addEventListener('click', function () {
        const label = previewButton.querySelector('[data-add-label]');
        label.textContent = root.dataset.previewLabel;
        window.setTimeout(function () {
          label.textContent = root.dataset.addLabel;
        }, 1200);
      });
    }

    function showIndexPanel(nextIndex) {
      indexTabs.forEach(function (tab, index) {
        const isActive = index === nextIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });
      indexPanels.forEach(function (panel, index) {
        panel.hidden = index !== nextIndex;
      });
    }

    indexTabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        showIndexPanel(index);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + indexTabs.length) % indexTabs.length;
        showIndexPanel(nextIndex);
        indexTabs[nextIndex].focus();
      });
    });

    function moveFeature(direction) {
      if (!featureTrack || window.innerWidth <= 540) return;
      const slide = featureTrack.querySelector('.dr-feature-card');
      featureIndex = Math.max(0, Math.min(featureCards.length - 1, featureIndex + direction));
      featureTrack.style.transform = 'translateX(-' + ((slide.getBoundingClientRect().width + 14) * featureIndex) + 'px)';
      featurePrev.disabled = featureIndex === 0;
      featureNext.disabled = featureIndex === featureCards.length - 1;
    }

    if (featurePrev && featureNext && featureCards.length) {
      featurePrev.disabled = true;
      featurePrev.addEventListener('click', function () {
        moveFeature(-1);
      });
      featureNext.addEventListener('click', function () {
        moveFeature(1);
      });
    }

    root.querySelectorAll('.dr-faq details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('.dr-faq details').forEach(function (item) {
          if (item !== details) item.open = false;
        });
      });
    });

    root.querySelectorAll('.dr-formula-card').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--dr-pointer-x', event.clientX - rect.left + 'px');
        card.style.setProperty('--dr-pointer-y', event.clientY - rect.top + 'px');
      });
    });

    if ('IntersectionObserver' in window) {
      const revealSections = Array.from(root.querySelectorAll('main > section:not(.dr-hero)'));
      if (!reducedMotion) root.classList.add('dr-motion-ready');
      const revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );
      revealSections.forEach(function (section) {
        revealObserver.observe(section);
      });

      if (hero && stickyBar) {
        const stickyObserver = new IntersectionObserver(
          function (entries) {
            stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { threshold: 0.1 }
        );
        stickyObserver.observe(hero);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-altis-product-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dr-product-story__faq').forEach(function (faq) {
    faq.querySelectorAll('details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        faq.querySelectorAll('details').forEach(function (item) {
          if (item !== details) item.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
